import React from 'react';
import PropTypes from 'prop-types';
import Spin from 'antd/lib/spin';
import PendingActionAlert from '../../dashboard/components/PendingActionAlert';
import DisposalItem from './DisposalItem';

const DisposalList = ({
  items,
  isFetching,
}) => (
  <Spin spinning={isFetching}>
    <div className="list-wrapper">
      {items.map(disposal => (
        <DisposalItem
          disposal={disposal}
          key={disposal.id}
        />
      ))}
    </div>
  </Spin>
);

DisposalList.propTypes = {
  items: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

export default DisposalList;



// WEBPACK FOOTER //
// ./src/features/disposals/components/DisposalList.js